export const sortingArray = (array, key) => [...array].sort((a, b) => a[key] - b[key]);